import { AxiosApi } from "./index";
import { useInfoStore } from "store/error";

export async function getPdfApi(guid: string) {
    const apiUri = "Pdf/Get"
    try {
        const registrations = await AxiosApi.get<string>(apiUri, {
            params: {
                guid
            }
        })

        return registrations.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error
    }
}

